
export function replaceVariables(
  template: string = '', 
  variables: Record<string, string> = {},
  ): string {
  // 使用正则表达式匹配变量的格式，例如 "${variable}"
  const variableRegex = /\${(.*?)}/g;

  // 使用 replace 方法替换字符串中的变量
  return template.replace(variableRegex, (match, variable) => {
    // 如果变量在 variables 对象中存在，则返回对应的值，否则保持原样
    return variables.hasOwnProperty(variable) ? variables[variable] : match;
  });
}
